import { ComboboxInput } from '@reach/combobox';
import 'react';
import { createComponent } from '../../../react/components/core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../../../react/components/head/stylesheets.component.js';

/**
 * @deprecated use new `Combobox` and its sub-components instead
 */ const LegacyComboboxInput = createComponent({
    displayName: 'LegacyComboboxInput',
    root: ComboboxInput,
    requiredStyleKeys: [
        SWAN_STYLE_KEY_MAP.legacyCombobox
    ],
    propConfig: {
        classNames: [
            'swan-input'
        ]
    }
});

export { LegacyComboboxInput };
